/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-13 16:27:06
 * @LastEditors: Wang Bin <email: binnuo1109@163.com> <tel: 13937670602>
 * @LastEditTime: 2021-08-13 15:09:45
 * @Description: 文件类型accept type
 * @FilePath: /hsylc2021/src/components/form/Uploader/acceptTypes.js
 */
export default {
  XLS: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  PDF: 'application/pdf',
  MP4: 'audio/mp4, video/mp4',
  MP3: 'audio/mpeg',
  IMAGE: 'image/*', // 接受所有图片类型
  GIF: 'image/gif',
  TIF: 'image/tiff',
  TIFF: 'image/tiff',
  JPG: 'image/jpeg',
  ZIP: 'application/zip, application/x-zip-compressed',
  RAR: 'application/x-rar-compressed, application/x-rar',
  PPT: 'application/vnd.ms-powerpoint',
  PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  DOC: 'application/msword, .doc',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document, .docx',
  AVI: 'video/x-msvideo',
  MOV: '.mov',
  PAGES: '.pages'
};
